import {
  PrivateRouteProps,
  PrivateRoute
} from '../../components/routes/private-route';
import {
  PublicRouteProps,
  PublicRoute
} from '../../components/routes/public-route';

/**
 * Converts a JSON route config map into a set of PublicRoute and PrivateRoutes
 *
 * @param props
 * @returns
 */
export function RouteConfigMap(props: {
  routeConfig: (
    | (PrivateRouteProps & { type: 'private' })
    | (PublicRouteProps & { type: 'public' })
  )[];
}) {
  return (
    <>
      {props.routeConfig.map((route, i) => {
        if (route.type === 'private') {
          return (
            <PrivateRoute
              key={i}
              roles={route.roles}
              path={route.path}
              component={route.component}
              redirectPath={route.redirectPath}
              redirectShouldPreserveSearchQuery={
                route.redirectShouldPreserveSearchQuery
              }
            />
          );
        }

        return (
          <PublicRoute
            key={i}
            path={route.path}
            component={route.component}
            redirectPath={route.redirectPath}
            publicOnly={route.publicOnly}
            redirectShouldPreserveSearchQuery={
              route.redirectShouldPreserveSearchQuery
            }
          />
        );
      })}
    </>
  );
}
